<template>
  <a-modal
    v-if="visible"
    title="Disable profile?"
    :visible="visible"
    width="560px"
    :destroy-on-close="true"
    @cancel="closeModal"
  >
    <div class="activity-disable-modal flex flex-column gap-3">
      <p>
        This will remove the associate’s access to the company and the app. They will no longer be able to adjust
        shifts, add shifts, or request payment for worked shifts.
      </p>

      <a-alert
        message="Only continue if you are sure the associate has finished all remaining company tasks. This profile will be disabled automatically 30 days after the separation date."
        show-icon
        type="warning"
      />

      <label class="activity-disable-modal__confirmation">
        <span>Type <b>disable</b> to confirm</span>
        <a-input v-model="disableConfirmation" placeholder="disable" />
        <div v-if="disableConfirmation !== requiredDisableConfirmation" class="activity-disable-modal__helper">
          Type disable to continue.
        </div>
      </label>
    </div>

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Cancel</a-button>
        <a-button type="danger" :loading="loadingDisable" :disabled="submitDisabled" @click="disableAssociate">
          Disable Profile
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Alert, Button, Input, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-alert': Alert,
    'a-button': Button,
    'a-input': Input,
    'a-modal': Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    associateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loadingDisable: false,
      disableConfirmation: '',
      requiredDisableConfirmation: 'disable'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.disableConfirmation = ''
      }
    }
  },
  computed: {
    submitDisabled() {
      return (
        this.loadingDisable ||
        !this.associateId ||
        this.disableConfirmation !== this.requiredDisableConfirmation
      )
    }
  },
  methods: {
    ...profileActions(['patchAssociateDeactivate', 'reloadAssociate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      if (this.loadingDisable) {
        return
      }

      this.$emit('update:visible', false)
      this.disableConfirmation = ''
    },

    async disableAssociate() {
      this.loadingDisable = true

      try {
        await this.patchAssociateDeactivate({
          associate_id: this.associateId
        })

        this.showNotification('success', 'Profile disabled.', '')
        this.$emit('update:visible', false)
        this.disableConfirmation = ''
        this.reloadAssociate(true)
      } catch (error) {
        this.showNotification(
          'error',
          'Profile could not be disabled. Try again or contact support if the issue continues.',
          typeof error === 'string' ? error : error?.message
        )
      } finally {
        this.loadingDisable = false
      }
    }
  }
}
</script>

<style scoped>
.activity-disable-modal p {
  margin: 0;
}

.activity-disable-modal__confirmation {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-weight: 600;
}

.activity-disable-modal__helper {
  color: #ef4444;
  font-size: 12px;
}
</style>
